export const enum EReportTags {
  REPORTS = 'reports',
  REPORT_CATEGORIES = 'reportCategories',
  REPORT_SUBCATEGORIES = 'reportSubcategories',
  REPORT_CATEGORY_CONFIG = 'reportCategoryConfig',
  SINGLE_REPORT_CONFIG = 'singleReportConfig',
  TYPE_REPORTS = 'typeReports',
  ADMIN_CATEGORIES = 'adminCategories',
  ADMIN_SUBCATEGORIES = 'adminSubcategories',
  DEFECT_UNUSED_SUBCATEGORIES = 'defectUnusedSubcategories',
  DEFAULT_STATUS_TYPE_REPORT = 'defaultStatusTypeReport',
  DEFECT_CONFIGURATION = 'defectConfiguration',
  REPORT_CONFIGS = 'reportConfigs',
  USER_SUBSCRIPTION = 'userSubscription',
  REPORT_STATUSES = 'reportStatuses',
  REPORT_SINGLE_SUBCATEGORIES = 'reportSingleSubcategories',
  ALL_SUBSCRIBER_REPORTS = 'allSubscriberReports',
  ALL_ADMIN_REPORTS = 'allAdminReports',
  OPTION_RESPONSES = 'optionResponses',
  SINGLE_REPORT = 'singleReport'
}

export type TReportsParams = {
  district: string;
};

export type TReportSubcategoriesParams = {
  district: string;
  categoryId: number;
};

export type TReportCategoryConfigParams = {
  prefix: string;
  configId: number;
};

export type TUserSubscriptionParams = {
  prefix: string;
  name_user: string;
  page: number;
  resultsPerPage: number;
  order: number;
  district: string;
};

export type TReportStatusesParams = {
  admin: boolean;
  page: number;
  resultsPerPage: number;
  paginationFalse: boolean;
};

export type TReportSingleSubcategoriesParams = {
  district: string;
  categoryId: number;
};

export type TAllReportsParams = {
  district: string;
  data: Partial<{
    search: string[];
    fieldSearchs: string[];
    ordering: string;
    descOrdering: boolean;
    page: number;
    pageSize: number;
    createdStart: moment.Moment;
    createdEnd: moment.Moment;
    category: number;
    subcategory: number[];
    status: string;
    confirmed: number;
    type: string;
  }>;
};

export type TOptionReports = {
  district: string;
};

export type TAllReportsParamsQuery = {
  ordering: string | null;
  search: string[] | undefined;
  page: number | undefined;
  page_size: number | undefined;
  category: number | undefined;
  subcategory: number[] | undefined;
  status: string | undefined;
  confirmed: number | undefined;
  type: string | undefined;
  created: string | null;
};

export type TSingleReportParams = {
  district: string;
  id: number;
};
